import { Box, BoxProps } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { LOGGED_IN_HOME_PAGE, MAX_NAVBAR_WIDTH } from "../config";
import { NavBar } from "../nav-bar/NavBar";
import { Logo } from "./Logo";
import { CgProfile } from "react-icons/cg";
import { useAPI } from "../api/useAPI";
import { Account } from "common";
import { useEffect, useState } from "react";
import { Avatar } from "../avatar/Avatar";
import { Banner } from "./Banner";

const HEADER_HEIGHT = "130px";
const BANNER_HEIGHT = "70px";
const NAV_BAR_HEIGHT = "80px";
export const PAGE_BODY_HEIGHT = `calc(100vh - ${HEADER_HEIGHT} - ${NAV_BAR_HEIGHT})`;

interface AppPageProps extends BoxProps {
  children: any;
  title?: string;
  padding?: number;
  customNavBar?: any;
  headerButton?: any;
}

export const AppPage = ({
  padding,
  children,
  title,
  customNavBar,
  headerButton,
  ...boxProps
}: AppPageProps) => {
  const api = useAPI();
  const accountId = api.getAccountId();
  const navigate = useNavigate();

  const [selfAccount, setSelfAccount] = useState<Account | null>(null);
  useEffect(() => {
    api.me().then((account) => setSelfAccount(account));
  }, [api]);

  return (
    <Box
      className="fullHeight"
      top={0}
      left={0}
      position={"fixed"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
      width={"100%"}
      overflowY={"hidden"}
    >
      {title ? (
        <Box
          width={"100%"}
          display={"flex"}
          flexDir={"column"}
          height={HEADER_HEIGHT}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            padding={2}
            height={"100%"}
            borderBottomWidth={1}
            borderBottomColor={"gray.300"}
            borderBottomStyle={"solid"}
            fontWeight={"bold"}
          >
            <Box display={"flex"} width={"100%"}>
              <Logo
                cursor={"pointer"}
                onClick={() => navigate(LOGGED_IN_HOME_PAGE)}
                width={35}
                height={35}
              />
            </Box>
            <Box width={"100%"} textAlign={"center"}>
              {title}
            </Box>
            <Box
              width={"100%"}
              display={"flex"}
              height={"100%"}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              {headerButton ?? (
                <Box
                  borderRadius={"full"}
                  aria-label="settings"
                  onClick={() => navigate(`/account/${accountId}`)}
                  height={"40px"}
                  minW={"40px"}
                >
                  {selfAccount ? (
                    <Avatar config={selfAccount.avatarConfig} round={true} />
                  ) : (
                    <CgProfile size={30} />
                  )}
                </Box>
              )}
            </Box>
          </Box>
          <Banner height={BANNER_HEIGHT} />
        </Box>
      ) : null}
      <Box
        width={"100%"}
        height={PAGE_BODY_HEIGHT}
        overflow={"auto"}
        display={"flex"}
        justifyContent={"center"}
      >
        <Box
          width={"100%"}
          maxWidth={MAX_NAVBAR_WIDTH}
          padding={padding ?? 4}
          {...boxProps}
        >
          {children}
        </Box>
      </Box>
      {customNavBar ? (
        <NavBar height={NAV_BAR_HEIGHT}>{customNavBar}</NavBar>
      ) : (
        <NavBar height={NAV_BAR_HEIGHT} />
      )}
    </Box>
  );
};
